export class ObligationUpdateGetModel {
    updateId: number;
    note: string;
    updateDate: string|Date;
    carrierName: string;
    carrierId: number;
    shortName: string;
    totalRecordCount: number;
    isFavorite: boolean;
    userId: number;
    Carrierinfo: any;
    cfr: string;
}

export class FilterObligationUpdateModel {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string;
    carrierId?: string | number;
    userId?: number;
    isFavorite?: number;
    fromDate?: string;
    toDate?: string;
    Note?: string;
    IsExport?:boolean;
}


export class CarrierFavoriteFilterModel {
    carrierTypeId?: string;
    clientId?: number;
    isFavourite?: number;
}

export class FilterObligationByUserModel {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string;
    userId?: number;
    category?: string;
    note?: string;
    carriertype?: string;
    favorite?: number;
}

export class FilterDeleteModel {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string;
    userId?: number;
    note?:string;
    category?:string;
    export?:boolean
}

export class ObligationDeleteModel {
    obligationId: number;
    cfr: string;
    url:string;
    carrierTypeName:string;
    title:string;
    details:string;
    deleteDeleteDelete:string;
    totalRecordCount:number;
}